import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

// URL 검색 파라미터 스키마
const contactSearchSchema = z.object({
  success: z.string().optional().catch(undefined),
  customerName: z.string().optional().catch(undefined),
  inquiryTypes: z.string().optional().catch(undefined),
});

/**
 * 문의하기 라우트 (/contact)
 *
 * TanStack Router의 autoCodeSplitting이 활성화되어 있으므로,
 * 컴포넌트는 contact.lazy.tsx에서 자동으로 코드 스플리팅됩니다.
 */
export const Route = createFileRoute('/contact')({
  validateSearch: contactSearchSchema,
});
